// import React from 'react';
// import moment from 'moment';

// const ArtisanJournalTemplate = ({ packageData, user }) => {
//     if (!packageData?.package) return <div>Loading...</div>;
//     const { package: pkg } = packageData;
//     const primaryColor = '#2F4F4F'; // Dark Slate Gray
//     const accentColor = '#C87563'; // Muted Terracotta
//     const backgroundColor = '#FDFBF7'; // Soft cream/off-white

//     return (
//         <div style={{ fontFamily: "'Lato', sans-serif", backgroundColor, color: '#333', padding: '40px' }}>
//             <style>
//                 {`@import url('https://fonts.googleapis.com/css2?family=Lora:wght@400;700&family=Lato:wght@400;700&display=swap');`}
//             </style>

//             {/* Asymmetric Header */}
//             <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '30px' }}>
//                 {user?.logo && <img src={user.logo} alt="Logo" style={{ maxHeight: '60px' }} />}
//                 <div style={{ textAlign: 'right' }}>
//                     <h1 style={{ fontFamily: "'Lora', serif", margin: 0, fontSize: '40px', color: primaryColor }}>{pkg.packageName}</h1>
//                     <p style={{ margin: '5px 0 0', fontSize: '18px', color: accentColor }}>A Curated Itinerary</p>
//                 </div>
//             </header>

//             {/* Hero Image */}
//             <img src={pkg.imageSrc} alt={pkg.packageName} style={{ width: '100%', height: '350px', objectFit: 'cover', marginBottom: '40px' }} />

//             {/* Overview & Summary */}
//             <section style={{ display: 'flex', gap: '40px', marginBottom: '40px' }}>
//                 <div style={{ flex: 2 }}>
//                     <h2 style={{ fontFamily: "'Lora', serif", fontSize: '28px', color: primaryColor }}>An Invitation to Discover</h2>
//                     <p style={{ fontSize: '16px', lineHeight: '1.8' }}>{pkg.description}</p>
//                 </div>
//                 <div style={{ flex: 1, borderLeft: `2px solid ${accentColor}`, paddingLeft: '30px' }}>
//                     <h3 style={{ fontFamily: "'Lora', serif", color: primaryColor, marginBottom: '20px' }}>Your Journey</h3>
//                     <div style={{ marginBottom: '15px' }}><strong>Duration:</strong> {pkg.duration}</div>
//                     <div style={{ marginBottom: '15px' }}><strong>Departs:</strong> {moment(pkg.startedDate).format("MMMM D, YYYY")}</div>
//                     <div style={{ fontSize: '22px' }}><strong>Cost:</strong> <span style={{ color: accentColor }}>{pkg.price} {pkg.currency}</span></div>
//                 </div>
//             </section>
            
//             {/* Itinerary */}
//             {packageData.itineraries?.length > 0 && (
//                 <section style={{ marginBottom: '40px' }}>
//                     <h2 style={{ fontFamily: "'Lora', serif", fontSize: '32px', textAlign: 'center', color: primaryColor, marginBottom: '30px' }}>The Daily Chronicle</h2>
//                     {packageData.itineraries.slice().sort((a, b) => new Date(a.date) - new Date(b.date)).map((item, index) => (
//                         <div key={index} style={{ padding: '20px 0', borderBottom: '1px solid #eee' }}>
//                             <div style={{ marginBottom: '10px' }}>
//                                 <span style={{ fontFamily: "'Lora', serif", fontSize: '20px', color: accentColor, marginRight: '15px' }}>Day {index + 1}</span>
//                                 <span style={{ fontSize: '18px', color: primaryColor, fontWeight: 'bold' }}>{item.title}</span>
//                             </div>
//                             <p style={{ margin: 0, paddingLeft: '65px', lineHeight: '1.7' }}>{item.description}</p>
//                         </div>
//                     ))}
//                 </section>
//             )}

//             {/* Accommodations & Flights */}
//             {packageData.hotelBookings?.length > 0 && (
//                 <section style={{ marginBottom: '40px' }}>
//                      <h2 style={{ fontFamily: "'Lora', serif", fontSize: '28px', color: primaryColor }}>Accommodations</h2>
//                      {packageData.hotelBookings.map((hotel, index) => (
//                          <div key={index} style={{ marginBottom: '10px' }}><strong>{hotel.city}:</strong> {hotel.hotelName} ({hotel.roomType})</div>
//                      ))}
//                 </section>
//             )}

//             {/* Inclusions */}
//             {packageData.includes?.length > 0 && (
//                 <section style={{ backgroundColor: '#F4F1ED', padding: '30px' }}>
//                     <h2 style={{ fontFamily: "'Lora', serif", fontSize: '28px', textAlign: 'center', color: primaryColor, marginBottom: '20px' }}>What We've Arranged For You</h2>
//                     <ul style={{ columns: 2, listStyle: 'none', padding: 0 }}>
//                         {packageData.includes.map((item, i) => (
//                             <li key={i} style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
//                                 <span style={{ position: 'absolute', left: 0, color: accentColor }}>&#10003;</span>{item.description}
//                             </li>
//                         ))}
//                     </ul>
//                 </section>
//             )}

//             {/* Footer */}
//             <footer style={{ marginTop: '40px', paddingTop: '20px', borderTop: `1px solid #ddd`, textAlign: 'center', fontSize: '14px', color: '#777' }}>
//                 <p>For inquiries, please contact your travel advisor at {pkg.contactEmail}.</p>
//                 <p style={{ marginTop: '5px' }}>We look forward to crafting your next adventure.</p>
//             </footer>
//         </div>
//     );
// };

// export default ArtisanJournalTemplate;

import React from 'react';
import moment from 'moment';

const ArtisanJournalTemplate = ({ packageData, user }) => {
    if (!packageData?.package) return <div>Loading...</div>;
    const { package: pkg } = packageData;

    // --- Style Palette ---
    const primaryColor = '#2F4F4F'; // Dark Slate Gray for text
    const accentColor = '#C87563'; // Muted Terracotta for highlights
    const backgroundColor = '#FDFBF7'; // Soft cream/off-white background
    const lightGray = '#eee'; // For subtle borders

    // --- Helper for Section Titles ---
    const SectionTitle = ({ children }) => (
        <h2 style={{
            fontFamily: "'Lora', serif",
            fontSize: '28px',
            color: primaryColor,
            marginBottom: '25px',
            paddingBottom: '10px',
            borderBottom: `1px solid ${lightGray}`
        }}>
            {children}
        </h2>
    );

    return (
        <div style={{ fontFamily: "'Lato', sans-serif", backgroundColor, color: '#333', padding: '40px' }}>
            {/* Custom Fonts */}
            {/* <style>
                {`@import url('https://fonts.googleapis.com/css2?family=Lora:wght@400;700&family=Lato:wght@400;700&display=swap');`}
            </style> */}

            {/* Asymmetric Header */}
            <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '30px' }}>
                {user?.logo && <img src={user.logo} alt="Logo" style={{ maxHeight: '100px' }} />}
                <div style={{ textAlign: 'right' }}>
                    <h1 style={{ fontFamily: "'Lora', serif", margin: 0, fontSize: '40px', color: primaryColor }}>{pkg.packageName}</h1>
                    <p style={{ margin: '5px 0 0', fontSize: '18px', color: accentColor }}>A Curated Itinerary</p>
                </div>
            </header>

            {/* Hero Image */}
            <img src={pkg.imageSrc} alt={pkg.packageName} style={{ width: '100%', height: '350px', objectFit: 'cover', marginBottom: '40px' }} />

            {/* Overview & Summary Section */}
            <section style={{ display: 'flex', gap: '40px', marginBottom: '40px' }}>
                <div style={{ flex: 2 }}>
                    <h2 style={{ fontFamily: "'Lora', serif", fontSize: '28px', color: primaryColor }}>An Invitation to Discover</h2>
                    <p style={{ fontSize: '16px', lineHeight: '1.8' }}>{pkg.description}</p>
                </div>
                <div style={{ flex: 1, borderLeft: `2px solid ${accentColor}`, paddingLeft: '30px' }}>
                    <h3 style={{ fontFamily: "'Lora', serif", color: primaryColor, marginBottom: '20px' }}>Your Journey</h3>
                    <div style={{ marginBottom: '15px' }}><strong>Duration:</strong> {pkg.duration}</div>
                    <div style={{ marginBottom: '15px' }}><strong>Departs:</strong> {moment(pkg.startedDate).format("MMMM D, YYYY")}</div>
                    <div style={{ fontSize: '22px' }}><strong>Cost:</strong> <span style={{ color: accentColor }}>{pkg.price} {pkg.currency}</span></div>
                </div>
            </section>
            
            {/* Itinerary Section */}
            {packageData.itineraries?.length > 0 && (
                <section style={{ marginBottom: '40px' }}>
                    <h2 style={{ fontFamily: "'Lora', serif", fontSize: '32px', textAlign: 'center', color: primaryColor, marginBottom: '30px' }}>The Daily Chronicle</h2>
                    {packageData.itineraries.slice().sort((a, b) => new Date(a.date) - new Date(b.date)).map((item, index) => (
                        <div key={index} style={{ padding: '20px 0', borderBottom: `1px solid ${lightGray}` }}>
                            <div style={{ marginBottom: '10px' }}>
                                <span style={{ fontFamily: "'Lora', serif", fontSize: '20px', color: accentColor, marginRight: '15px' }}>Day {index + 1}</span>
                                <span style={{ fontSize: '18px', color: primaryColor, fontWeight: 'bold' }}>{item.title}</span>
                            </div>
                            <p style={{ margin: 0, paddingLeft: '65px', lineHeight: '1.7' }}>{item.description}</p>
                             {item.meals && <p style={{ margin: '5px 0 0', paddingLeft: '65px', fontSize: '14px', color: '#777' }}><strong>Meals:</strong> {item.meals}</p>}
                        </div>
                    ))}
                </section>
            )}

            {/* Flight Details Section */}
            {packageData.flightBookings?.length > 0 && (
                <section style={{ marginBottom: '40px' }}>
                    <SectionTitle>Flight Arrangements</SectionTitle>
                    {packageData.flightBookings.map((flight, index) => (
                        <div key={index} style={{ border: `1px solid ${lightGray}`, padding: '20px', marginBottom: '15px', borderRadius: '4px' }}>
                            <h4 style={{ fontFamily: "'Lora', serif", margin: '0 0 15px', color: primaryColor }}>{flight.airline} - Flight {flight.flightNumber}</h4>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px' }}>
                                <div>
                                    <p style={{ margin: 0 }}><strong>From:</strong> {flight.departureCity}</p>
                                    <p style={{ margin: '5px 0 0' }}><strong>Departs:</strong> {moment(flight.departureDateTime).format("MMM D, YYYY 'at' h:mm a")}</p>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                    <p style={{ margin: 0 }}><strong>To:</strong> {flight.arrivalCity}</p>
                                    <p style={{ margin: '5px 0 0' }}><strong>Arrives:</strong> {moment(flight.arrivalDateTime).format("MMM D, YYYY 'at' h:mm a")}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </section>
            )}

            {/* Accommodations Section */}
            {packageData.hotelBookings?.length > 0 && (
                <section style={{ marginBottom: '40px' }}>
                     <SectionTitle>Curated Accommodations</SectionTitle>
                     {packageData.hotelBookings.map((hotel, index) => (
                         <div key={index} style={{ padding: '15px 0', borderBottom: `1px solid ${lightGray}` }}>
                            <h4 style={{fontFamily: "'Lora', serif", margin: 0, color: primaryColor}}>{hotel.hotelName}</h4>
                            <p style={{margin: '5px 0 0', color: '#555'}}><strong>City:</strong> {hotel.city}</p>
                            <p style={{margin: '5px 0 0', color: '#555'}}>
                                <strong>Stay:</strong> {moment(hotel.checkInDate).format("MMM D")} - {moment(hotel.checkOutDate).format("MMM D, YYYY")}
                            </p>
                            <p style={{margin: '5px 0 0', color: '#555'}}><strong>Room Type:</strong> {hotel.roomType}</p>
                         </div>
                     ))}
                </section>
            )}
            
            {/* Sightseeing & Transfers Section */}
            {(packageData.sightSeeings?.length > 0 || packageData.transfers?.length > 0) && (
                <section style={{ marginBottom: '40px' }}>
                    <SectionTitle>Explorations & Transfers</SectionTitle>
                     {packageData.sightSeeings?.length > 0 && (
                        <div>
                            <h4 style={{fontFamily: "'Lora', serif", color: primaryColor, marginBottom: '15px'}}>Sightseeing Details</h4>
                            {packageData.sightSeeings.map((sight, index) => (
                                <p key={index} style={{margin: '0 0 10px'}}>
                                    <strong>{moment(sight.date).format("MMM D")}:</strong> Visit {sight.sightseeingName} in {sight.destination}.
                                </p>
                            ))}
                        </div>
                     )}
                     {packageData.transfers?.length > 0 && (
                         <div style={{marginTop: '25px'}}>
                            <h4 style={{fontFamily: "'Lora', serif", color: primaryColor, marginBottom: '15px'}}>Transfer Services</h4>
                             {packageData.transfers.map((transfer, index) => (
                                <p key={index} style={{margin: '0 0 10px'}}>
                                    <strong>{moment(transfer.date).format("MMM D")} at {transfer.pickupTime}:</strong> Transfer from {transfer.fromLocation} to {transfer.toLocation} via {transfer.vehicleDetails}.
                                </p>
                             ))}
                         </div>
                     )}
                </section>
            )}

            {/* Inclusions & Exclusions Section */}
            {(packageData.includes?.length > 0 || packageData.excludes?.length > 0) && (
                <section style={{ backgroundColor: '#F4F1ED', padding: '30px', marginBottom: '40px' }}>
                    <h2 style={{ fontFamily: "'Lora', serif", fontSize: '28px', textAlign: 'center', color: primaryColor, marginBottom: '30px' }}>The Finer Details</h2>
                    <div style={{ display: 'flex', gap: '30px' }}>
                        {packageData.includes?.length > 0 && (
                            <div style={{flex: 1}}>
                                <h3 style={{ fontFamily: "'Lora', serif", fontSize: '22px', color: primaryColor }}>What We've Arranged</h3>
                                <ul style={{ listStyleType: 'none', padding: 0 }}>
                                    {packageData.includes.map((item, i) => (
                                        <li key={i} style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                                            <span style={{ position: 'absolute', left: 0, color: accentColor }}>&#10003;</span>{item.description}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {packageData.excludes?.length > 0 && (
                            <div style={{flex: 1}}>
                                <h3 style={{ fontFamily: "'Lora', serif", fontSize: '22px', color: primaryColor }}>What Is Not Included</h3>
                                <ul style={{ listStyleType: 'none', padding: 0 }}>
                                    {packageData.excludes.map((item, i) => (
                                        <li key={i} style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                                            <span style={{ position: 'absolute', left: 0, color: '#999' }}>&#10007;</span>{item.description}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </section>
            )}

            {/* Terms & Conditions Section */}
            {packageData.termsandConditions?.length > 0 && (
                <section style={{ marginBottom: '40px' }}>
                    <SectionTitle>Terms & Conditions</SectionTitle>
                     {packageData.termsandConditions.map((term, index) => (
                        <div key={index} style={{ marginBottom: '15px' }}>
                            <h4 style={{ fontFamily: "'Lora', serif", color: primaryColor, fontSize: '18px' }}>{term.title}</h4>
                            <p style={{ lineHeight: '1.7', color: '#555' }}>{term.description}</p>
                        </div>
                     ))}
                </section>
            )}


            {/* Footer */}
            <footer style={{ marginTop: '40px', paddingTop: '20px', borderTop: `1px solid ${lightGray}`, textAlign: 'center', fontSize: '14px', color: '#777' }}>
                <p>For inquiries, please contact your travel advisor at {pkg.contactEmail}.</p>
                <p style={{ marginTop: '5px' }}>We look forward to crafting your next adventure.</p>
            </footer>
        </div>
    );
};

export default ArtisanJournalTemplate;